import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import image from './no_results.svg';
const containerCss = "c12iiggu";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const queryParserOptions = query => ({
  Bold: () => <strong>{query}</strong>
});
export const EmptyState = ({
  query
}) => <Container>
    <img src={image} alt="" height={160} />
    <HeadingText size="large">
      {I18n.t('publisher.meetings.search.results.no_results.title')}
    </HeadingText>
    <BodyText color="muted">
      {HtmlParser(I18n.t('publisher.meetings.search.results.no_results.description'), queryParserOptions(query))}
    </BodyText>
  </Container>;

require("./empty_state.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./empty_state.js");